export default __webpack_public_path__ + "static/media/1.66ade07a.jpg";